var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppDataAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-app-data",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-app-data:not(.animated) .animable {opacity: 0;}svg#freepik_stories-app-data.animated #freepik--background-complete--inject-145 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-app-data.animated #freepik--Table--inject-145 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-app-data.animated #freepik--Device--inject-145 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-app-data.animated #freepik--Plant--inject-145 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-app-data.animated #freepik--speech-bubble--inject-145 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-app-data.animated #freepik--Character--inject-145 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-145",
    className: "animable",
    style: {
      transformOrigin: "247.629px 238.39px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.77,
    y: 378.66,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "80.35px 384.255px"
    },
    id: "el19shb1jhph6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.89,
    y: 248.15,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "101.47px 253.745px"
    },
    id: "elbbbas4jvuyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,404c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45V404l0-11.19v-.5h.5l17.58.07c4.37,0,13.2.13,17.58.19h.24v.24L78.32,404Zm0,0-.24-11.19.24.24c-4.39.06-13.2.15-17.58.19l-17.58.07.5-.5,0,11.19-.46-.46,8.71,0c5.57.07,20.68.32,26.45.42Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "60.66px 398.36px"
    },
    id: "elw4aax9nd63k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,205.76c-5.86.1-20.63.35-26.29.41l-8.87,0h-.46v-.46l0-11.19v-.5h.5l17.58.07c4.37,0,13.2.13,17.58.19h.24v.24l-.23,11.19Zm0,0L277,194.57l.24.23c-4.39.07-13.2.16-17.58.2l-17.58.07.5-.5-.05,11.19-.45-.46,8.71,0c5.57.07,20.68.32,26.45.42Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "259.58px 200.095px"
    },
    id: "elxd93dht2hk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.63,219.87c-5.85.1-20.62.35-26.29.41l-8.86,0H222v-.45l0-11.19v-.5h.51l17.57.07c4.38,0,13.21.13,17.58.19h.25v.24l-.24,11.19Zm0,0-.23-11.19.23.23c-4.38.07-13.19.16-17.58.2l-17.57.07.5-.5,0,11.19-.45-.46,8.71,0c5.57.07,20.68.32,26.44.42Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "239.955px 214.21px"
    },
    id: "elr3posaah2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.94,
    y: 194.57,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "220.52px 200.165px"
    },
    id: "el8x4het6rit5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.68,
    y: 392.77,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "439.26px 398.365px"
    },
    id: "elmwd9h44744q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.07,
    y: 47.22,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "419.65px 52.815px"
    },
    id: "el0pan3f6bukn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.84,72.52c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45v-.45l-.05-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.19h.24v.24l-.24,11.19Zm0,0-.24-11.19.24.23c-4.39.07-13.19.16-17.58.2l-17.58.07.5-.5,0,11.19-.46-.46,8.71,0c5.58.07,20.69.32,26.45.42Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "439.13px 66.86px"
    },
    id: "elsm4u9ft8pq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,58.41c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45v-.46l0-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.19h.24v.24l-.24,11.19Zm0,0-.24-11.19.24.23c-4.39.07-13.2.16-17.58.2l-17.58.07.5-.5,0,11.19L62.77,58l8.71,0c5.57.07,20.68.32,26.45.42Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "80.27px 52.745px"
    },
    id: "elkbg2nftsz4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.67,429.7c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45v-.46l0-11.19V418h.5l17.58.07c4.38,0,13.2.13,17.58.19h.24v.24l-.23,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.15-17.58.19l-17.58.07.5-.5,0,11.19-.46-.46,8.71,0c5.57.07,20.68.32,26.45.42Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "283.01px 424.055px"
    },
    id: "eljjlcfbu2j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,119.71a35.75,35.75,0,1,1-35.35-41v35.75Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "73.7338px 114.46px"
    },
    id: "elvxxkomqeseh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,107.19a34.85,34.85,0,0,1-.39,5.24l-35.35-5.24V71.44A35.71,35.71,0,0,1,117,107.19Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "99.13px 91.935px"
    },
    id: "elwg61gf18ke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.81,
    y: 127.16,
    width: 38.01,
    height: 1,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "96.815px 127.66px"
    },
    id: "elkbioed17r2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.49,130.82a3.17,3.17,0,1,1,3.16-3.16A3.17,3.17,0,0,1,118.49,130.82Zm0-5.33a2.17,2.17,0,1,0,2.16,2.17A2.17,2.17,0,0,0,118.49,125.49Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "118.48px 127.65px"
    },
    id: "el96u5u6p102q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.15,
    y: 125.66,
    width: 29.53,
    height: 1.33,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "142.915px 126.325px"
    },
    id: "elpyycj4q3ghr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.15,
    y: 128.32,
    width: 16.71,
    height: 1.33,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "136.505px 128.985px"
    },
    id: "elc0ae0u9cpsv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.71,
    y: 255.72,
    width: 9.43,
    height: 67.1,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "228.425px 289.27px"
    },
    id: "elnv593aiwgpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.92,
    y: 271.96,
    width: 9.43,
    height: 50.86,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "244.635px 297.39px"
    },
    id: "el00ebkucu5g9qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.12,
    y: 297.39,
    width: 9.43,
    height: 25.43,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "260.835px 310.105px"
    },
    id: "elbpfjex2g7sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.33,
    y: 282.86,
    width: 9.43,
    height: 39.95,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "277.045px 302.835px"
    },
    id: "elps7brcuoqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.54,
    y: 267.61,
    width: 9.43,
    height: 55.21,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "293.255px 295.215px"
    },
    id: "eld3uro1ya976",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.74,
    y: 258.64,
    width: 9.43,
    height: 64.18,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "309.455px 290.73px"
    },
    id: "elw1knmadmzmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.24,247.18l.11,18.91L218.4,285l.08,37.82-.24-.24q13,0,26,0l26,.06,26,.05,26,.14-26,.14-26,.05-26,.05q-13,0-26,0H218v-.23l.08-37.82,0-18.91Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "270.12px 285.125px"
    },
    id: "elkj3kecyqor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,251a8.15,8.15,0,0,1,4.16,0,8.45,8.45,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 250.995px"
    },
    id: "el54ehm3g42c4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,256.72a8.45,8.45,0,0,1,4.16,0,7.08,7.08,0,0,1-2.08.27A7.43,7.43,0,0,1,216.16,256.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 256.726px"
    },
    id: "elmztwhb39rnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,262.47a8.45,8.45,0,0,1,4.16,0,8.15,8.15,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 262.475px"
    },
    id: "elu91iqwekz5f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,268.22a8.15,8.15,0,0,1,4.16,0,8.15,8.15,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 268.22px"
    },
    id: "el0plgawp7lt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,274a8.15,8.15,0,0,1,4.16,0,8.15,8.15,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 274px"
    },
    id: "elpn1uj1612oe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,279.72a8.15,8.15,0,0,1,4.16,0,8.45,8.45,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 279.715px"
    },
    id: "eljjfbv1um02o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,285.46a8.45,8.45,0,0,1,4.16,0,8.15,8.15,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 285.465px"
    },
    id: "elhry4okfxz5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,291.21a8.45,8.45,0,0,1,4.16,0,8.15,8.15,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 291.215px"
    },
    id: "elnt90xvk2ji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,297a8.15,8.15,0,0,1,4.16,0,8.15,8.15,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 297px"
    },
    id: "elipxwzfwot8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,302.71a8.15,8.15,0,0,1,4.16,0,8.15,8.15,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 302.71px"
    },
    id: "elnsnhwbms2a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,308.46a8.15,8.15,0,0,1,4.16,0,8.45,8.45,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 308.455px"
    },
    id: "elzcm9zoo59n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.16,314.21a7.43,7.43,0,0,1,2.08-.27,7.08,7.08,0,0,1,2.08.27,8.45,8.45,0,0,1-4.16,0Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "218.24px 314.204px"
    },
    id: "elqflcjwthrt",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-145",
    className: "animable",
    style: {
      transformOrigin: "249.99px 452.752px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.49,452.75c133.58-.61,283.44-.61,417,0-133.58.62-283.44.61-417,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.99px 452.752px"
    },
    id: "eldtxkgw1s3hd",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-145",
    className: "animable",
    style: {
      transformOrigin: "364.055px 227.845px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446,42.29H282.09a16.73,16.73,0,0,0-16.58,16.89V396.51a16.75,16.75,0,0,0,16.58,16.89H446a16.76,16.76,0,0,0,16.6-16.89V59.18A16.75,16.75,0,0,0,446,42.29Zm6.22,343.79c0,8.88-6.65,16.07-14.85,16.07H290.73c-8.22,0-14.87-7.19-14.87-16.07V72c0-18.09,6.65-19,14.87-19H320.1c1.71,0,3.1,1.94,3.1,4.34v1c0,5.63,3.09,5.65,6.87,5.65H398c3.82,0,6.88,0,6.88-5.65v-1c0-2.4,1.38-4.34,3.11-4.34h29.36c8.2,0,14.85,2.41,14.85,19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.055px 227.845px"
    },
    id: "elyuzg2zcbey",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.18,72V386.08c0,8.88-6.65,16.07-14.85,16.07H290.73c-8.22,0-14.87-7.19-14.87-16.07V72c0-18.09,6.65-19,14.87-19H320.1c1.71,0,3.1,1.94,3.1,4.34v1c0,5.63,3.09,5.65,6.87,5.65H398c3.82,0,6.88,0,6.88-5.65v-1c0-2.4,1.38-4.34,3.11-4.34h29.36C445.53,53,452.18,55.4,452.18,72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364.02px 227.575px"
    },
    id: "el752qb0gnz3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-145",
    className: "animable",
    style: {
      transformOrigin: "311.83px 60.93px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315,60.05c-.09.09-.19.18-.28.28l-.16.16a3.87,3.87,0,0,0-5.47,0l-.16-.16-.28-.28h0l0,0,.35-.31a4.41,4.41,0,0,1,1.93-.9c.19,0,.37-.05.55-.08H312l.38,0a4.39,4.39,0,0,1,1,.25,4.6,4.6,0,0,1,.68.31,5.06,5.06,0,0,1,.65.46l.3.27Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "311.83px 59.625px"
    },
    id: "el6xq580xifii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,61.38l-.45-.44a3.18,3.18,0,0,1,1.82-.92,3.23,3.23,0,0,1,2.75.91l-.45.45a2.6,2.6,0,0,0-3.67,0Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "311.835px 60.683px"
    },
    id: "el71qtjmc09ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.24,61.83l-.45.45a1.28,1.28,0,0,0-.94-.39,1.29,1.29,0,0,0-.94.39l-.44-.45A2,2,0,0,1,313.24,61.83Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "311.855px 61.7764px"
    },
    id: "eld8kn3dkq8th",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.26,62.68a.41.41,0,1,1-.41-.4A.4.4,0,0,1,312.26,62.68Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "311.85px 62.6899px"
    },
    id: "els4w1p5fjx7i",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.36,60.9a1.17,1.17,0,1,1,1.17,1.17A1.17,1.17,0,0,1,287.36,60.9Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "288.53px 60.9px"
    },
    id: "elu1pwu0098bp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,60.9a1.17,1.17,0,1,1,1.17,1.17A1.17,1.17,0,0,1,291,60.9Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "292.17px 60.9px"
    },
    id: "ele01yd0zwmeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.72,60.9a1.17,1.17,0,1,1,1.17,1.17A1.17,1.17,0,0,1,294.72,60.9Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "295.89px 60.9px"
    },
    id: "elikv2bhmco4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.41,60.9a1.17,1.17,0,1,1,1.16,1.17A1.16,1.16,0,0,1,298.41,60.9Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "299.58px 60.9px"
    },
    id: "elk5uzoyoq8es",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.09,60.9a1.17,1.17,0,1,1,1.16,1.17A1.16,1.16,0,0,1,302.09,60.9Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "303.26px 60.9px"
    },
    id: "el6ywcsiabsza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,63.46h-9.51V59.05H439Zm-9-.49h8.55V59.53h-8.55Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "434.245px 61.255px"
    },
    id: "elncu8wdri43",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.24,
    y: 59.8,
    width: 6.13,
    height: 2.91,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "433.305px 61.255px"
    },
    id: "elex4qc6gmpff",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.97,
    y: 60.07,
    width: 0.85,
    height: 2.36,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "439.395px 61.25px"
    },
    id: "elo3wz4z9gjqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.29,57H354.77a1.15,1.15,0,0,1-1.15-1.15h0a1.15,1.15,0,0,1,1.15-1.14h18.52a1.15,1.15,0,0,1,1.15,1.14h0A1.15,1.15,0,0,1,373.29,57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364.03px 55.855px"
    },
    id: "elsath1jedwyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.79 383.66 297.93 383.66 297.93 387.62 296.31 387.62 296.31 385.61 293.46 385.61 293.46 387.62 291.85 387.62 291.85 383.66 290.99 383.66 294.89 379.63 298.79 383.66",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "294.89px 383.625px"
    },
    id: "elrllybfcmsuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.06,
    y: 379.63,
    width: 9.4,
    height: 1.34,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.76px 380.3px"
    },
    id: "elb2h6bggobmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.06,
    y: 382.96,
    width: 9.4,
    height: 1.34,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.76px 383.63px"
    },
    id: "elgc5p4kapyfv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.06,
    y: 386.28,
    width: 9.4,
    height: 1.34,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.76px 386.95px"
    },
    id: "eloc0xfhizeum",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.49 383.77 364.82 386.62 362.14 383.77 362.62 383.32 364.82 385.67 367.02 383.32 367.49 383.77",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "364.815px 384.97px"
    },
    id: "el43x6rw7kf5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.82,389.57a4.86,4.86,0,1,1,4.85-4.86A4.87,4.87,0,0,1,364.82,389.57Zm0-9.07a4.22,4.22,0,1,0,4.21,4.21A4.22,4.22,0,0,0,364.82,380.5Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "364.81px 384.71px"
    },
    id: "el58c17k3oksf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.2,
    y: 76.4,
    width: 157.66,
    height: 46.02,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "364.03px 99.41px"
    },
    id: "el6zrdta039ei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.17 91.19 288.96 86.3 294.17 81.42 294.98 82.28 290.69 86.3 294.98 90.32 294.17 91.19",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "291.97px 86.305px"
    },
    id: "el70wppo98bmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.11,83.26a1,1,0,1,1-1-1A1,1,0,0,1,439.11,83.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "438.11px 83.26px"
    },
    id: "elmzddpxb57s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.11,86.91a1,1,0,1,1-1-1A1,1,0,0,1,439.11,86.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "438.11px 86.91px"
    },
    id: "elo2c6sonncnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.11,90.55a1,1,0,1,1-1-1A1,1,0,0,1,439.11,90.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "438.11px 90.55px"
    },
    id: "eltl95vso6pdo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.09,86.3c18.14-.67,36.41-.67,54.56,0-18.15.67-36.42.67-54.56,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.37px 86.3px"
    },
    id: "elmnw9zksnu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.09,91.19c12.25-.33,25.73-.33,38,0-12.25.33-25.73.32-38,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "321.09px 91.1881px"
    },
    id: "elugq7gapdly",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.13,108c28.12-.31,59.67-.31,87.78,0-28.11.31-59.66.31-87.78,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364.02px 108px"
    },
    id: "elfqg50edxwm5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.38,160.23c24.88-.18,49.77-.14,74.65-.21s49.77,0,74.66.21c-24.89.17-49.77.13-74.66.2S317.26,160.4,292.38,160.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "367.035px 160.223px"
    },
    id: "elfhepcl1prfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.38,177c24.88-.17,49.77-.13,74.65-.2s49.77,0,74.66.2c-24.89.18-49.77.14-74.66.21S317.26,177.22,292.38,177Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "367.035px 177.006px"
    },
    id: "eltefnb24wo4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.38,193.86c24.88-.17,49.77-.13,74.65-.2s49.77,0,74.66.2c-24.89.18-49.77.14-74.66.21S317.26,194,292.38,193.86Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "367.035px 193.861px"
    },
    id: "elrbmr3mj9pih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.38,210.68c24.88-.17,49.77-.13,74.65-.2s49.77,0,74.66.2c-24.89.18-49.77.13-74.66.21C342.15,210.81,317.26,210.86,292.38,210.68Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "367.035px 210.672px"
    },
    id: "eletsa57yktin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.38,227.5c24.88-.18,49.77-.13,74.65-.2s49.77,0,74.66.2c-24.89.18-49.77.13-74.66.21C342.15,227.63,317.26,227.68,292.38,227.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "367.035px 227.492px"
    },
    id: "el52h3n2i885c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.44,149.29c.22,15.72.16,31.43.26,47.15-.09,15.71,0,31.43-.26,47.14-.22-15.71-.16-31.43-.25-47.14C322.28,180.72,322.22,165,322.44,149.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "322.445px 196.435px"
    },
    id: "elghk32bi01he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.26,149.29c.22,15.72.16,31.43.26,47.15-.1,15.71,0,31.43-.26,47.14-.22-15.71-.16-31.43-.25-47.14C348.1,180.72,348,165,348.26,149.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "348.265px 196.435px"
    },
    id: "elxypl72u4exr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.08,149.29c.22,15.72.16,31.43.25,47.15-.09,15.71,0,31.43-.25,47.14-.22-15.71-.16-31.43-.26-47.14C373.92,180.72,373.86,165,374.08,149.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "374.075px 196.435px"
    },
    id: "eldh9mp83tcgv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.9,149.29c.22,15.72.16,31.43.25,47.15-.09,15.71,0,31.43-.25,47.14-.22-15.71-.17-31.43-.26-47.14C399.74,180.72,399.68,165,399.9,149.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "399.895px 196.435px"
    },
    id: "elsmcr6ebdp4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.72,149.29c.22,15.72.16,31.43.25,47.15-.09,15.71,0,31.43-.25,47.14-.22-15.71-.17-31.43-.26-47.14C425.55,180.72,425.5,165,425.72,149.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "425.715px 196.435px"
    },
    id: "elau0lo24k5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrzjsm5ltj4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.14,215.3c4.56,0,7.28-17.08,13.73-17.08s7.14,12.46,12.57,12.46,5.27-21.89,12.57-21.89,5.61,8.88,13.25,8.88S353,177,361,177s4.76,28.42,13.08,28.42c5.27,0,7.3-9,13.59-9,4.16,0,6.61,4.51,12.05,4.51s6.63-17.36,13.43-17.36,7.57,10.27,12.57,10.27,6.79-16.82,16-16.82v66.54H296.14Z",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.5,
      transformOrigin: "368.93px 210.28px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elo4azgaer9kj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.14,215.3c4.56,0,7.28-17.08,13.73-17.08s7.14,12.46,12.57,12.46,5.27-21.89,12.57-21.89,5.61,8.88,13.25,8.88S353,177,361,177s4.76,28.42,13.08,28.42c5.27,0,7.3-9,13.59-9,4.16,0,6.61,4.51,12.05,4.51s6.63-17.36,13.43-17.36,7.57,10.27,12.57,10.27,6.79-16.82,16-16.82v66.54H296.14Z",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.3,
      transformOrigin: "368.93px 210.28px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.14,216.12v-1.64c1.38,0,3.28-4,4.67-6.9,2.38-5,4.85-10.18,9.06-10.18,4,0,6.05,3.79,7.82,7.13,1.39,2.62,2.82,5.33,4.75,5.33,1.7,0,3.17-5.26,4.25-9.1,1.76-6.29,3.58-12.79,8.32-12.79,4.23,0,5.89,2.55,7.35,4.8s2.65,4.08,5.9,4.08c2.94,0,4.09-4.82,5.2-9.48,1.31-5.48,2.66-11.15,7.54-11.15s6.08,7.14,7.39,14.7c1.06,6.11,2.37,13.72,5.69,13.72,2,0,3.6-1.88,5.32-3.86,2.08-2.42,4.45-5.17,8.27-5.17,2.29,0,4.08,1.12,5.81,2.21s3.69,2.31,6.24,2.31c1.89,0,3.61-4.13,5-7.45,2-4.87,4.13-9.91,8.44-9.91s6.38,3.28,8.24,6.17c1.36,2.11,2.64,4.1,4.33,4.1,1.44,0,3.06-3.19,4.5-6,2.45-4.82,5.5-10.81,11.47-10.81v1.65c-4.6,0-7.24,5.2-9.58,9.78-2,3.93-3.58,7-6.39,7s-4.49-2.43-6.14-5-3.4-5.27-6.43-5.27c-2.84,0-4.78,4.67-6.5,8.79-1.92,4.59-3.57,8.56-6.93,8.56s-5.5-1.41-7.49-2.65c-1.59-1-3-1.86-4.56-1.86-2.75,0-4.7,2.26-6.6,4.46s-3.94,4.56-7,4.56c-5.09,0-6.37-7.35-7.72-15.13-1-5.92-2.3-13.28-5.36-13.28s-4.44,5.21-5.53,9.81c-1.33,5.56-2.58,10.81-7.21,10.81s-6.2-2.63-7.71-5c-1.36-2.1-2.55-3.92-5.54-3.92s-4.89,6.38-6.33,11.52c-1.62,5.79-2.91,10.37-6.24,10.37s-4.9-3.07-6.63-6.33c-1.6-3-3.25-6.13-5.94-6.13s-5.21,5.06-7.15,9.12C300.6,212.61,298.93,216.12,296.14,216.12Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "368.92px 196.17px"
    },
    id: "elwpg009ascj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elppfyxtcblq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.08,205.46v38.12H348.26V197.67C355.9,197.67,353,177,361,177S365.76,205.46,374.08,205.46Z",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.5,
      transformOrigin: "361.17px 210.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 360.99,
    cy: 176.51,
    r: 4.09,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.99px 176.51px"
    },
    id: "elha000ulvnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.33,176.51a2.34,2.34,0,1,1-2.34-2.34A2.34,2.34,0,0,1,363.33,176.51Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "360.99px 176.51px"
    },
    id: "el041y33h2r1jq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.52,
    y: 159.84,
    width: 14.84,
    height: 8.28,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "360.94px 163.98px"
    },
    id: "elv2etjlrn61",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.98 168.12 362.89 168.12 360.94 170.93 358.98 168.12",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "360.935px 169.525px"
    },
    id: "elt4ve6ihqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.29,162.9a86.69,86.69,0,0,1,9.4,0,92.1,92.1,0,0,1-9.4,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "360.99px 162.896px"
    },
    id: "elj3eqpz9oova",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.29,164.5a86.69,86.69,0,0,1,9.4,0,89.31,89.31,0,0,1-9.4,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "360.99px 164.498px"
    },
    id: "elg4hdr4x0v47",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.14,150.31c.17,15.55.31,31.09.32,46.64l.16,46.63-.48-.38,72.77.09,36.39.08,36.39.21-36.39.21-36.39.08-72.77.1h-.48v-.39l.16-46.63C295.83,181.4,296,165.86,296.14,150.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "368.675px 197.14px"
    },
    id: "elikqxtewbf1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.93,250.56a34.66,34.66,0,0,1,10.37,0,35.33,35.33,0,0,1-10.37,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "309.115px 250.556px"
    },
    id: "eluay4w9qpdld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,160.23a7.34,7.34,0,0,1,4.72,0,7.47,7.47,0,0,1-4.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "287.56px 160.226px"
    },
    id: "el2pdizjen89i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,177a7.47,7.47,0,0,1,4.72,0,7.34,7.34,0,0,1-4.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "287.56px 177.004px"
    },
    id: "el1zaerhgw9i4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,193.86a7.47,7.47,0,0,1,4.72,0,7.34,7.34,0,0,1-4.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "287.56px 193.864px"
    },
    id: "eltk7x5ujjp9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,210.68a7.47,7.47,0,0,1,4.72,0,7.34,7.34,0,0,1-4.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "287.56px 210.684px"
    },
    id: "elh63v8gmumir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2,227.5a7.4,7.4,0,0,1,4.72,0,7.4,7.4,0,0,1-4.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "287.56px 227.5px"
    },
    id: "el96nkwrp08e7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37,250.56a34.6,34.6,0,0,1,10.36,0,35.27,35.27,0,0,1-10.36,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "334.55px 250.556px"
    },
    id: "elp2sy5tdpfa9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,250.56a34.66,34.66,0,0,1,10.37,0,35.33,35.33,0,0,1-10.37,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "359.985px 250.556px"
    },
    id: "elixrq1yubof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,250.56a34.66,34.66,0,0,1,10.37,0,35.33,35.33,0,0,1-10.37,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "385.415px 250.556px"
    },
    id: "el8cgezwit15h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.66,250.56a34.66,34.66,0,0,1,10.37,0,35.33,35.33,0,0,1-10.37,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "410.845px 250.556px"
    },
    id: "el71q0l3k33ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.1,250.56a34.66,34.66,0,0,1,10.37,0,35.33,35.33,0,0,1-10.37,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "436.285px 250.556px"
    },
    id: "elwxpydo39iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,134.15c14.64-.68,29.39-.68,44,0-14.65.68-29.4.68-44,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "307.33px 134.15px"
    },
    id: "el90qh6z9ap2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.33,138.78a193,193,0,0,1,28.25,0,195.86,195.86,0,0,1-28.25,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "299.455px 138.776px"
    },
    id: "elehk4jd4bd5d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.44,138.78a261,261,0,0,1,28.25,0,266.21,266.21,0,0,1-28.25,0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "427.565px 138.776px"
    },
    id: "elgy4a3pb0rz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.31,266c14.8-.68,29.73-.68,44.54,0-14.82.68-29.74.68-44.54,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "308.58px 266px"
    },
    id: "el6ys3t4t58cm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.05,266q16.81-.75,33.64,0-16.81.76-33.64,0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "424.87px 266.003px"
    },
    id: "elke3wmwbz8it",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,280a298.82,298.82,0,0,1,35,0,301,301,0,0,1-35,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.13px 279.998px"
    },
    id: "eld2dlk7xwdv5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,285.13a211.53,211.53,0,0,1,29.36,0,211.53,211.53,0,0,1-29.36,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.31px 285.13px"
    },
    id: "el20tztcdu96j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.69,301.62c-.35-.34-156.08,1-155.72,0l0-27.32v-.38h.38L364,274c25.93.06,51.86,0,77.8.16,0,.09-.15,27.32-.11,27.43Zm0,0-.11-27.32c-25.19.46-51.89.09-77.58.26.35-.27-79.48.73-77.32-.26l0,27.32c-2.12-.93,155.52.29,155.05,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "363.885px 287.959px"
    },
    id: "el4n41rh983wb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 278.23,
    width: 19.8,
    height: 19.8,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.23px 288.13px"
    },
    id: "el9szf908zja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.14,288.13a9.9,9.9,0,1,1-1.31-4.92A9.9,9.9,0,0,1,437.14,288.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "427.24px 288.132px"
    },
    id: "elys6bgf1xr9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.83,283.21l-8.59,4.92v-9.9A9.91,9.91,0,0,1,435.83,283.21Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "431.535px 283.18px"
    },
    id: "elkwuzll3144",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.24,
    cy: 288.13,
    r: 6.85,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.24px 288.13px"
    },
    id: "eloon3ou2re7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,315.11a301,301,0,0,1,35,0,301,301,0,0,1-35,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.13px 315.11px"
    },
    id: "elujj4e4q5i9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,320.26a211.53,211.53,0,0,1,29.36,0,211.53,211.53,0,0,1-29.36,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.31px 320.26px"
    },
    id: "elag4pg5ejz8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.69,336.75c-.35-.34-156.08,1-155.72,0l0-27.32v-.38h.38l77.69.11c25.93.06,51.86,0,77.8.16,0,.09-.15,27.32-.11,27.43Zm0,0-.11-27.32c-25.19.46-51.89.09-77.58.26.35-.27-79.48.73-77.32-.26l0,27.32c-2.12-.93,155.52.29,155.05,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "363.905px 323.089px"
    },
    id: "el6zwq5e40v3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 313.36,
    width: 19.8,
    height: 19.8,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "300.23px 323.26px"
    },
    id: "elopf11w1xte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.14,323.26a9.9,9.9,0,1,1-1.31-4.92A9.9,9.9,0,0,1,437.14,323.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "427.24px 323.262px"
    },
    id: "elxvpyzk70vte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.14,323.26a9.9,9.9,0,0,1-.11,1.45l-9.79-1.45v-9.9a9.9,9.9,0,0,1,9.9,9.9Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "432.19px 319.035px"
    },
    id: "el4pqmt9305f4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08,323.26a6.85,6.85,0,1,1-6.84-6.84A6.85,6.85,0,0,1,434.08,323.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.23px 323.27px"
    },
    id: "elog6eofgearr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,350.24a301,301,0,0,1,35,0,301,301,0,0,1-35,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.13px 350.24px"
    },
    id: "elyllimcxgskk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,355.39a211.53,211.53,0,0,1,29.36,0,211.53,211.53,0,0,1-29.36,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "331.31px 355.39px"
    },
    id: "elmyq08k8gxia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.69,371.88c-.35-.34-156.08,1-155.72,0l0-27.32v-.38h.38l77.69.11c25.93.06,51.86,0,77.8.16,0,.09-.15,27.32-.11,27.43Zm0,0-.11-27.32c-25.19.46-51.89.09-77.58.26.35-.27-79.48.73-77.32-.26l0,27.32c-2.12-.93,155.52.29,155.05,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "363.905px 358.219px"
    },
    id: "elw6yxfsb7ttj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.33,
    y: 348.49,
    width: 19.8,
    height: 19.8,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "300.23px 358.39px"
    },
    id: "elttdxwz5py8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.14,358.39a9.89,9.89,0,0,1-6.35,9.24,9.78,9.78,0,0,1-3.55.66,9.9,9.9,0,1,1,9.9-9.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "427.24px 358.39px"
    },
    id: "elvb2gur5832k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.14,358.39a9.89,9.89,0,0,1-6.35,9.24l-3.55-9.24v-9.9a9.9,9.9,0,0,1,9.9,9.9Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "432.19px 358.06px"
    },
    id: "el66ywjual3iu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08,358.39a6.85,6.85,0,1,1-6.84-6.84A6.85,6.85,0,0,1,434.08,358.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "427.23px 358.4px"
    },
    id: "elst7c5q014j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-145",
    className: "animable",
    style: {
      transformOrigin: "426.36px 391.44px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457,362.27c-12.36,16.75-25.26,36.18-28.4,57.19a.28.28,0,0,0,.55.11,124.61,124.61,0,0,1,5.46-16.82c8.13-2.24,16.12-4.08,20.38-12.15,4.36-8.29,3.81-19.11,3-28.15C457.88,362,457.22,362,457,362.27Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "443.571px 390.941px"
    },
    id: "el3ckz933iwm5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.71,402.59c5.55-12.47,12.69-25,21.75-35.24.06-.07.16,0,.1.1-5.94,7.3-10.45,15.26-14.85,23.35,4.1-4.16,8.58-7.88,12.46-12.29.08-.09.2,0,.13.12-3.86,4.62-8.06,9.65-13.08,13.07-1.35,2.48-2.7,5-4.08,7.46.34-.19.69-.36,1-.53.06,0,.12.06.06.09-.39.2-.77.4-1.16.57-.65,1.18-1.3,2.36-2,3.53C435,403.08,434.59,402.85,434.71,402.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "445.633px 385.128px"
    },
    id: "elh1azt92vjnb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.84,398.24a72.59,72.59,0,0,0,9.49-6.34c.08-.06.2.05.12.12a49.94,49.94,0,0,1-9.47,6.45A.13.13,0,0,1,438.84,398.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "443.626px 395.186px"
    },
    id: "el7lcqfuaml7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.14,416.34c0,.25.46.25.45,0,.07-6.92,0-13.87.11-20.82,1.77-3.57,5.58-5.55,8.22-8.42a36.47,36.47,0,0,0,4.93-6.87,49.14,49.14,0,0,0,5.73-19.08c.73-7.4-2.08-31.81-5.2-31-1.62.43-6.85,12.53-8.24,16.53A115.56,115.56,0,0,0,428.22,367C425.69,383.24,425.9,400,427.14,416.34Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "436.472px 373.329px"
    },
    id: "el1ih9otbfljb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.09,386.5l0,0c.38-8.75,2.35-17.59,4.2-26.08,2-9.14,4.31-17.75,9-25.91.08-.15.31,0,.23.14a96.18,96.18,0,0,0-7.24,19.89c.31-.5.69-1,1-1.43.13-.18.43,0,.31.18a12.75,12.75,0,0,1-1.48,2.07.07.07,0,0,1-.06,0c-1.62,6.54-2.78,13.22-3.77,19.89.07-.08.14-.17.22-.25s.13,0,.1.07c-.12.23-.26.44-.4.67-.5,3.38-1,6.76-1.43,10.11,6-5.15,11.17-11.23,14.08-18.71,0,0,.07,0,.05,0-2.84,7.76-7.32,14.66-14.23,19.37-.12.9-.25,1.8-.38,2.7,0,.18-.32.14-.32-.05,0-.79,0-1.59.07-2.39A.19.19,0,0,1,427.09,386.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "434.437px 361.887px"
    },
    id: "elrou0p3hqghd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.93,373.82c4.61-6.88,8.91-13.55,12.28-21.15a.08.08,0,0,1,.15.06c-2.84,7.55-6.82,15.2-12.2,21.27A.15.15,0,0,1,429.93,373.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "436.141px 363.326px"
    },
    id: "elz0sgz63z6mk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.05,351c1.91-3.38,3.92-6.66,5.72-10.1.05-.1.18,0,.14.08a52.46,52.46,0,0,1-5.57,10.19A.17.17,0,0,1,436.05,351Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "438.978px 346.046px"
    },
    id: "elbdtgbt783q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.3,352.44a0,0,0,1,1,0,.06S435.27,352.44,435.3,352.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "435.293px 352.47px"
    },
    id: "ellg37mfwntb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.46,396.33A70.79,70.79,0,0,1,420.84,410c.07.49.14,1,.22,1.49a64.71,64.71,0,0,0,2.43-15.19.46.46,0,0,0,0-.47h0A100.79,100.79,0,0,0,422,375.2c-2.14-12.72-6.82-24.92-15.69-34.44a.63.63,0,0,0-1,.2c-3.58,9.1-2.33,20,.72,29a53,53,0,0,0,7,13.79C416.11,388.05,420,391.66,422.46,396.33Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "413.342px 376.041px"
    },
    id: "eleo3t9t6k1f6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.35,345c8.4,13.64,14.25,29.81,15,45.92,0,.28-.47.36-.51.06-.2-1.44-.42-2.88-.65-4.31h0c-3.48-3.33-7.05-6.84-9.54-11,0-.08.07-.16.12-.1A116.41,116.41,0,0,0,421,385.66q-.9-5.34-2.15-10.52c-.23-.25-.45-.52-.67-.78s.1-.42.25-.25l.2.23a120.7,120.7,0,0,0-4.39-13.95c-2.14-2.55-4.53-4.76-6.09-7.83,0-.07.06-.13.11-.07,1.25,1.76,2.47,3.53,3.89,5.16.56.65,1.19,1.26,1.77,1.89A107.45,107.45,0,0,0,407,345.2C406.9,345,407.22,344.81,407.35,345Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.665px 368.046px"
    },
    id: "elszm34mtb0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.05,361.84c2.71,3.65,5.81,7.14,8.33,10.92.07.1-.08.21-.17.13-3.25-3-6-7.2-8.35-10.95C408.79,361.82,409,361.73,409.05,361.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.122px 367.354px"
    },
    id: "eluljjuubwq6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.76,373.6l.12.12c.08.08-.05.2-.13.12l-.11-.11C417.56,373.65,417.68,373.52,417.76,373.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.759px 373.721px"
    },
    id: "elexuw3mb865k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.18,371.23a41.93,41.93,0,0,0,8.87,20.8,22,22,0,0,0,7.19,5.61c3.11,1.54,6.37,3.32,9.6,4.58a63.35,63.35,0,0,1,3.39,12.07c.11-.35.21-.72.31-1.07-2.06-17.76-13.56-33-28.26-42.69A.72.72,0,0,0,394.18,371.23Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "408.857px 392.354px"
    },
    id: "el34d8s3spsou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.26,376.48c-.1-.1,0-.28.15-.2a60.16,60.16,0,0,1,18.74,23.09c.1.24-.23.46-.37.21-.68-1.19-1.38-2.36-2.09-3.5h0c-3.35-.63-6.53-3-9-5.24-.07-.06,0-.16.1-.1a20.55,20.55,0,0,0,4.24,3c1.37.69,2.84,1.13,4.27,1.68-1.25-2-2.54-3.86-3.89-5.7A39.14,39.14,0,0,1,401.29,384c-.1-.07,0-.22.09-.16a102,102,0,0,0,9.38,5,86,86,0,0,0-6.62-7.72c-1.14-.6-2.3-1.2-3.4-1.85a.09.09,0,0,1,.07-.17,12.37,12.37,0,0,1,2.61,1.28C402.09,379.09,400.73,377.77,399.26,376.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.694px 387.975px"
    },
    id: "el1oh1otqo9hu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,382.61a4.39,4.39,0,0,1,.56.4c.06.05,0,.12-.07.1a5,5,0,0,1-.59-.34C399.38,382.71,399.47,382.54,399.58,382.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "399.801px 382.853px"
    },
    id: "elux46ttvd2fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "446.49 452.75 406.2 452.75 409.45 416.06 410.17 407.97 442.52 407.97 443.24 416.06 446.49 452.75",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "426.345px 430.36px"
    },
    id: "elm3rcuf5bxug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.24 416.06 409.45 416.06 410.17 407.97 442.52 407.97 443.24 416.06",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "426.345px 412.015px"
    },
    id: "elb8hs9mp4mu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.24,
    y: 402.32,
    width: 36.21,
    height: 8.01,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "426.345px 406.325px"
    },
    id: "elnusgm52hc4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-145",
    className: "animable",
    style: {
      transformOrigin: "222.11px 99.4032px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.39,99.42a34.43,34.43,0,0,1-55,27.64l-16.87,4.31,7-15.71a34.44,34.44,0,1,1,64.8-16.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "222.455px 99.4202px"
    },
    id: "elylu7ow19lb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,99.42a34.66,34.66,0,0,1-55.17,27.93l.3.06-16.85,4.38-.88.23.37-.83,7-15.73v.43a34.29,34.29,0,0,1-4.1-15.17c-.72-16.12,10.71-31.33,26.45-34.94,21.51-5.5,43.07,11.48,42.88,33.64Zm0,0c.07-22.09-21.36-38.85-42.74-33.11C200.4,70,189.21,85.05,190,100.68a34.24,34.24,0,0,0,4,14.75l.11.21-.09.22L187,131.55l-.5-.61,16.89-4.22.16,0a34.22,34.22,0,0,0,54.88-27.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.11px 99.4032px"
    },
    id: "el8zztv9c40g4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.37 119.91 202.94 104.28 208.12 99.16 217.14 108.29 235.87 78.92 242.01 82.84 218.37 119.91",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "222.475px 99.415px"
    },
    id: "elicuzgh81mr",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-145",
    className: "animable",
    style: {
      transformOrigin: "195.23px 296.247px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206,228.5a13.32,13.32,0,0,0,6.93-23.13c5.3-1.3,9.8-5.07,10.12-11,.34-6.15-4.1-10.82-9.9-12,0,0-.06.06,0,.08,5.15,1.66,9.33,6.17,8.94,11.84-.33,4.85-3.43,7.82-7.38,9.44a14.74,14.74,0,0,0,5.17-10.54A11.4,11.4,0,0,0,213,182.55c2.06-4.72,2.62-10.48-.08-15.08a11.41,11.41,0,0,0-11.1-5.71,12.75,12.75,0,0,0-18.75-14.06A10.7,10.7,0,0,0,169.32,136a7.19,7.19,0,0,0-4.57-6.3c-3-1.28-6.3-.58-9.23.61a8.61,8.61,0,0,0-7.37-3.7,7.82,7.82,0,0,0-7.25,7.08c-5-1.21-10.6-1.82-15.28.7-3.85,2.08-6.74,6.25-6.22,10.69a15.48,15.48,0,0,0-17.11,15.61,10.88,10.88,0,0,0-8.19,7.14,16.05,16.05,0,0,0-1,7.7,8.15,8.15,0,0,0-6,7.42c-.21,3.42,1.46,6.16,3.76,8.41a6.18,6.18,0,0,1,0,2.75A14.15,14.15,0,0,0,94.6,207a9.66,9.66,0,0,0,5,13.62,10.86,10.86,0,0,0,8.42,12.7,15.83,15.83,0,0,0,4,12.53c2.41,2.58,6.2,4.42,9.58,3.1-.06,2.78,2.77,4.75,5.46,5a13.64,13.64,0,0,0,3.06-.17c1.19-.18,2.68-.72,3.88-.46s2.13,1.45,3.1,2.18a12.49,12.49,0,0,0,2.25,1.34,14.38,14.38,0,0,0,17.37-4.67c3.76,2.8,8.78,1.76,12.66-.46a25.73,25.73,0,0,0,3.5-2.56,6.3,6.3,0,0,1,3.39-1.72c.84-.1,1.71,0,2.56-.1,2.88-.31,4.83-2.3,6.52-4.47C195.71,249.93,207.33,239.92,206,228.5ZM88.22,184.58a8.6,8.6,0,0,1,5-8.62c0,.27.1.44.1.44s-.89.79-1.28,1.22a10.73,10.73,0,0,0-1.71,2.65,11.19,11.19,0,0,0-.9,6.45,11.84,11.84,0,0,0,.88,2.8c0,.12.08.23.13.34A10.5,10.5,0,0,1,88.22,184.58ZM149.81,129a8.29,8.29,0,0,0-8.15,4.87l-.27-.07c.93-3.42,2.72-6.29,6.82-6.47a7.23,7.23,0,0,1,6.37,3.39l-.05,0A9.1,9.1,0,0,0,149.81,129ZM185.69,242.4a.86.86,0,0,0,.07-.1,14.94,14.94,0,0,0,18.87-8.78C202.13,241.76,195.2,247.43,185.69,242.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.075px 192.327px"
    },
    id: "elk2ma42i2yj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.1,288.81c20.26,43.35,54.6,102,70.36,104.47,9.52,1.48,25.62,2.77,37.85-8.76,26.7-25.15,45-61.08,55.14-79.53,4.6-8.38-46.87-45.66-53.34-37.75-15.17,18.5-32.28,54.36-35.09,54.25-10.38-.42-25.78-25.69-50.93-49.12C147.8,244.13,145.45,270.29,154.1,288.81Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "233.735px 327.083px"
    },
    id: "elg4xe22fn5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.11,316.72c12.72-13.57,29.42-33.79,29.46-42.3,0-8.92-1.07-40.32-3.68-47.53s-16.58-25.81-23-28.26c-5.13-2-7.87,4.38-1.91,15.9,6.67,12.88,4.63,18.08,4.94,22.21.32,4.28-6.85,22.48-12.86,24-3.55.91-10.91.87-12.58-5.53s0-12.18-2.47-23.34c-1.94-8.68-9.19-14.07-12.18-12.55s-.51,6.71-2.48,19.71c-1.23,8.11-2.43,13.93-12.1,25.78-8.46,10.37-9,24.73-9,24.73Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "295.91px 257.493px"
    },
    id: "elfp9edgaine",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,254.41c-.35-4.89,3-19.71,1.84-26.17s-8.74-30.24-16-32.18c-9.09-2.43-6.39,16.9-4.46,25.19s-3.37,23.23-3.37,23.23l12.51,5.32Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "330.208px 225.13px"
    },
    id: "eltczs75ljm0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.38,247.89c2.24-7.52,5-15.16,5.13-23.06-.39-5.66-1.52-11.23-1.79-16.93-.08-3.38-.29-7.07,1.42-10.13a3.82,3.82,0,0,1,2.78-1.87,3.83,3.83,0,0,0-2.55,2c-1.43,3.08-1.09,6.63-.88,9.95.38,4.5,1.12,9,1.7,13.51,1.17,9.17-2.55,18.14-5.81,26.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.15px 221.895px"
    },
    id: "elvvr7s3zdwua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.74,258.67c1-4.76,8.29-17.92,9-24.42s.06-31.35-6.28-35.3c-8-5-10.74,14.25-11.19,22.72s-9.64,21.16-9.64,21.16l10.42,8.7Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "335.299px 228.402px"
    },
    id: "elp9o9ebaqln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.94,245.55c4.22-6.52,9-13,11.25-20.52,1.2-5.49,1.66-11.11,3-16.61.86-3.24,1.67-6.82,4.15-9.25a3.74,3.74,0,0,1,3.17-1,3.71,3.71,0,0,0-3,1.17c-2.21,2.54-2.87,6-3.59,9.22-.88,4.4-1.41,8.86-2.11,13.33-1.4,9.05-7.44,16.59-12.87,23.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "329.725px 221.838px"
    },
    id: "elqledubzz7pt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.65,257c-5.84,4.84-14,6.64-21.4,7.13A39.18,39.18,0,0,0,283,268.31a49.94,49.94,0,0,0-4.91,2.83,35.72,35.72,0,0,1,21.08-8c7.43-.52,15.15-2,21.47-6.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "299.37px 264.065px"
    },
    id: "elkvk5wbg6e6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.12,201.22,312.66,272.9a4.58,4.58,0,0,1-5,2.86l-35.95-7.16a3.12,3.12,0,0,1-2.31-4.31l26.46-71.67a4.55,4.55,0,0,1,5-2.87l35.95,7.16A3.12,3.12,0,0,1,339.12,201.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "304.26px 232.754px"
    },
    id: "elof02ysdldr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.6,196.47l-36-7.15a4.55,4.55,0,0,0-5,2.86l-26.46,71.67a3.12,3.12,0,0,0,2.31,4.31l36,7.16a4.56,4.56,0,0,0,5-2.86l26.46-71.67A3.12,3.12,0,0,0,334.6,196.47ZM309,269.79a4.2,4.2,0,0,1-4.51,2.76l-32.17-6.4a2.89,2.89,0,0,1-2-4.06L295,195.35c1.42-3.85,3-3.74,4.75-3.38l6.44,1.28c.38.07.53.55.34,1.06l-.08.22c-.44,1.19.23,1.33,1.06,1.5l14.9,3c.84.16,1.51.29,2-.9l.08-.22c.19-.52.64-.87,1-.79l6.44,1.28c1.8.36,3.07,1.16,1.77,4.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.027px 232.319px"
    },
    id: "eluc8gc4bfonj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.88,
    y1: 257.86,
    x2: 271.76,
    y2: 257.83,
    style: {
      fill: "none",
      transformOrigin: "271.82px 257.845px"
    },
    id: "elzf57ezgy47",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.64,203.05,309,269.79a4.2,4.2,0,0,1-4.51,2.76l-32.17-6.4a2.89,2.89,0,0,1-2-4.06L295,195.35c1.42-3.85,3-3.74,4.75-3.38l6.44,1.28c.38.07.53.55.34,1.06l-.08.22c-.44,1.19.23,1.33,1.06,1.5l14.9,3c.84.16,1.51.29,2-.9l.08-.22c.19-.52.64-.87,1-.79l6.44,1.28C333.67,198.73,334.94,199.53,333.64,203.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "302.108px 232.196px"
    },
    id: "elovobygrtc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5zjqx--inject-145",
    className: "animable",
    style: {
      transformOrigin: "303.895px 194.572px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.49,194.53l-.09,0,0,0a.7.7,0,0,0-.51-.36,1.07,1.07,0,0,0-.69.12l0,0,0-.07h0l.1-.06.23-.07a1.24,1.24,0,0,1,.27,0h.23l.08,0a.72.72,0,0,1,.2.09l.13.1a.64.64,0,0,1,.1.13l.05.07Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "303.895px 194.306px"
    },
    id: "el87z2it61md2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.28,194.59l-.06-.11a.81.81,0,0,1,.47-.12.64.64,0,0,1,.53.32l-.13.07a.49.49,0,0,0-.35-.24A.69.69,0,0,0,303.28,194.59Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "303.72px 194.554px"
    },
    id: "el53518jex4gb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,194.83l-.13.07a.27.27,0,0,0-.17-.12.34.34,0,0,0-.24,0l-.06-.11A.42.42,0,0,1,304,194.83Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "303.7px 194.752px"
    },
    id: "eljqw8nezu0o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67,195a.11.11,0,0,1-.12.06.08.08,0,0,1-.06-.1.12.12,0,0,1,.12-.07A.08.08,0,0,1,303.67,195Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "303.582px 194.976px"
    },
    id: "el2tghg8ian42",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.35,193.5a.33.33,0,0,1,.35-.2.22.22,0,0,1,.16.3.31.31,0,0,1-.35.2A.22.22,0,0,1,298.35,193.5Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "298.605px 193.551px"
    },
    id: "elkb3xhm606g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.16,193.66a.32.32,0,0,1,.35-.2.22.22,0,0,1,.16.3.32.32,0,0,1-.35.2A.22.22,0,0,1,299.16,193.66Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "299.415px 193.71px"
    },
    id: "elkpqeh77lai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,193.82a.33.33,0,0,1,.34-.2.22.22,0,0,1,.17.3.32.32,0,0,1-.35.2A.21.21,0,0,1,300,193.82Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "300.252px 193.871px"
    },
    id: "eljks9b6es80f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.77,194a.32.32,0,0,1,.35-.19.22.22,0,0,1,.17.3.33.33,0,0,1-.35.19A.22.22,0,0,1,300.77,194Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "301.03px 194.054px"
    },
    id: "elmeo28hh2fmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58,194.14a.32.32,0,0,1,.35-.19.21.21,0,0,1,.16.3.32.32,0,0,1-.35.19A.22.22,0,0,1,301.58,194.14Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "301.837px 194.195px"
    },
    id: "el09iixa8l3big",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.41,200.67l-2.09-.42.35-.94,2.08.42Zm-1.94-.5,1.87.37.27-.73-1.88-.37Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "330.535px 199.99px"
    },
    id: "elb45tw3yua8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.13 199.78 329.78 199.51 329.55 200.13 330.9 200.39 331.13 199.78",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "330.34px 199.95px"
    },
    id: "elk3f0l7uvwvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.68 200.49 331.49 200.45 331.67 199.95 331.86 199.98 331.68 200.49",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "331.675px 200.22px"
    },
    id: "elwscms8gtj99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.51,196.42l-4.07-.81a.21.21,0,0,1-.16-.29h0a.32.32,0,0,1,.34-.19l4.07.81a.21.21,0,0,1,.16.29h0A.31.31,0,0,1,317.51,196.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "315.565px 195.776px"
    },
    id: "el8wt7eozpvrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.54 262.57 275.35 262.54 275.04 263.38 274.69 263.31 274.85 262.88 274.22 262.75 274.06 263.18 273.71 263.11 274.02 262.27 273.83 262.23 275 261.55 275.54 262.57",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "274.625px 262.465px"
    },
    id: "el9dukk5qzeop",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.39 268.11 304.33 267.69 304.44 267.41 306.5 267.82 306.39 268.11",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "305.415px 267.76px"
    },
    id: "elz745hfv5fu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.13 268.81 304.07 268.4 304.18 268.12 306.24 268.52 306.13 268.81",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "305.155px 268.465px"
    },
    id: "el7m7tsj73whs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.87 269.52 303.81 269.11 303.92 268.82 305.98 269.23 305.87 269.52",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "304.895px 269.17px"
    },
    id: "elvba9xy1cqzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.61 265.6 289.8 266.09 289.43 265.36 289.57 265.29 289.87 265.88 290.54 265.48 290.61 265.6",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "290.02px 265.69px"
    },
    id: "el19d4ope8e99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,266.71a.9.9,0,0,1-.68-1.24,1.32,1.32,0,0,1,1.45-.82.9.9,0,0,1,.68,1.24A1.32,1.32,0,0,1,289.56,266.71Zm.71-1.92a1.13,1.13,0,0,0-1.25.71.79.79,0,0,0,.59,1.08,1.15,1.15,0,0,0,1.26-.72A.78.78,0,0,0,290.27,264.79Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "289.945px 265.68px"
    },
    id: "elulqm20la0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.47 200.23 296.71 198.97 298.24 198.16 298.35 198.37 297.09 199.04 297.71 200.08 297.47 200.23",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "297.53px 199.195px"
    },
    id: "el4owiof1ni7s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.89,204.88a.28.28,0,0,1-.31.17.18.18,0,0,1-.14-.26.27.27,0,0,1,.3-.17A.19.19,0,0,1,329.89,204.88Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "329.662px 204.835px"
    },
    id: "elnqwj3kywb0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.6,205.65a.28.28,0,0,1-.3.18.2.2,0,0,1-.15-.27.29.29,0,0,1,.31-.17A.19.19,0,0,1,329.6,205.65Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "329.375px 205.61px"
    },
    id: "el04jxkaeboovb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31,206.43a.27.27,0,0,1-.3.17.19.19,0,0,1-.15-.26.28.28,0,0,1,.31-.17A.18.18,0,0,1,329.31,206.43Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "329.088px 206.385px"
    },
    id: "el8bxsjkq4ewq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.45,201c4.5.73,9,1.62,13.36,2.66-4.5-.72-9-1.61-13.36-2.66Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "313.13px 202.33px"
    },
    id: "elahk7zbmot6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.86,204.37a95.94,95.94,0,0,1,9.66,1.92,95.94,95.94,0,0,1-9.66-1.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "298.69px 205.33px"
    },
    id: "elcnevisgn3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.27,213.22a44.15,44.15,0,0,1,6.55,1.31,43.15,43.15,0,0,1-6.55-1.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "322.545px 213.875px"
    },
    id: "ellhmg4x44yim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,213.93a43.15,43.15,0,0,1,6.55,1.31,43.9,43.9,0,0,1-6.55-1.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "322.275px 214.585px"
    },
    id: "elnd08sy6r5nm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,205.35a39.44,39.44,0,0,1,6.19,1.24,39.44,39.44,0,0,1-6.19-1.24Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "296.595px 205.97px"
    },
    id: "el4tfyckgb5mb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.08,211,301,219.65l-3.52,9.53a8.35,8.35,0,0,1-6.31-11.49,12.2,12.2,0,0,1,13.35-7.58A9.42,9.42,0,0,1,307.08,211Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "298.795px 219.563px"
    },
    id: "elj803xi12l7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,228.48a11.47,11.47,0,0,1-6.52.7l3.52-9.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "300.74px 224.511px"
    },
    id: "el0t787xs01uvl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.83,221.6a12.12,12.12,0,0,1-6.84,6.88l-3-8.83,9.87-4.47A8.88,8.88,0,0,1,310.83,221.6Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "306.218px 221.83px"
    },
    id: "elgrvub6k69l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.19,214.7l-11.33,5.13,7-9.91A9.34,9.34,0,0,1,312.19,214.7Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "306.525px 214.875px"
    },
    id: "el0incjpln9jrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.91,220.62a6.1,6.1,0,0,1-6.68,3.79,4.18,4.18,0,0,1-3.16-5.74,6.1,6.1,0,0,1,6.68-3.79A4.16,4.16,0,0,1,305.91,220.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.994px 219.645px"
    },
    id: "elqqbb00ecr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.95 213.89 316.9 213.68 317.27 212.66 318.33 212.87 317.95 213.89",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "317.615px 213.275px"
    },
    id: "el5a7td4jtvws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,215.91a43.15,43.15,0,0,1,6.55,1.31,43.9,43.9,0,0,1-6.55-1.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "321.555px 216.565px"
    },
    id: "elt01h664yir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,216.62a44.39,44.39,0,0,1,6.55,1.3,43.88,43.88,0,0,1-6.55-1.3Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "321.275px 217.27px"
    },
    id: "elkztji4mpapo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.96 216.58 315.9 216.37 316.28 215.34 317.34 215.56 316.96 216.58",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.62px 215.96px"
    },
    id: "el5lht87lddx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.28,218.6a43,43,0,0,1,6.56,1.31,44.28,44.28,0,0,1-6.56-1.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "320.56px 219.255px"
    },
    id: "elujatrh45vpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,219.31a43.88,43.88,0,0,1,6.55,1.3,44.39,44.39,0,0,1-6.55-1.3Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "320.275px 219.96px"
    },
    id: "elvbyfshl8s2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.97 219.27 314.91 219.06 315.29 218.03 316.35 218.24 315.97 219.27",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "315.63px 218.65px"
    },
    id: "el7uice19iizq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,221.29a43.88,43.88,0,0,1,6.55,1.3,44.39,44.39,0,0,1-6.55-1.3Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "319.565px 221.94px"
    },
    id: "elkva0v2g3p5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,222a43.88,43.88,0,0,1,6.55,1.3A44.39,44.39,0,0,1,316,222Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "319.275px 222.65px"
    },
    id: "elscq0whtxx0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.98 221.96 313.92 221.75 314.3 220.72 315.36 220.93 314.98 221.96",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "314.64px 221.34px"
    },
    id: "eluq6oncxbnnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.59 263.86 293.27 263.4 301.39 241.42 303.7 241.88 295.59 263.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "298.485px 252.64px"
    },
    id: "elprrm2l2zy3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5,230.33c6.24,1.07,12.76,2.37,18.89,3.76-6.24-1.08-12.77-2.37-18.89-3.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.945px 232.21px"
    },
    id: "elo0i0tjhr1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.05,231.55c3.55.54,7.07,1.24,10.5,2.09-3.55-.53-7.07-1.23-10.5-2.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "289.3px 232.595px"
    },
    id: "el5s0r402vhla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.21,235.65a74.09,74.09,0,0,1,7.38,1.47,75.24,75.24,0,0,1-7.38-1.47Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "314.9px 236.385px"
    },
    id: "el4th5wh6up8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.04 250.68 279.29 250.53 283.7 238.57 284.46 238.72 280.04 250.68",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "281.875px 244.625px"
    },
    id: "el4bedd9lt1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.82 259.41 276.06 259.25 278.9 251.56 279.66 251.72 276.82 259.41",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "277.86px 255.485px"
    },
    id: "elnqb0vnsknys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.51 246.47 284.76 246.31 287.35 239.3 288.11 239.45 285.51 246.47",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "286.435px 242.885px"
    },
    id: "elfsld30sx8dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.47 260.13 279.71 259.98 284.38 247.35 285.13 247.5 280.47 260.13",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "282.42px 253.74px"
    },
    id: "ela3dch21ulad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.56 243.4 289.8 243.25 291 240.02 291.75 240.17 290.56 243.4",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "290.775px 241.71px"
    },
    id: "elzjaaq6s9oqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.12 260.86 283.36 260.71 289.42 244.28 290.18 244.44 284.12 260.86",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "286.77px 252.57px"
    },
    id: "ely5pl5s6kyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.12 249.79 291.36 249.64 294.64 240.75 295.4 240.9 292.12 249.79",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "293.38px 245.27px"
    },
    id: "elixsl3rrcdyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.76 261.58 287.01 261.43 290.98 250.68 291.74 250.83 287.76 261.58",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "289.375px 256.13px"
    },
    id: "ele44pk84sfwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.46 248.64 295.7 248.49 298.29 241.47 299.05 241.63 296.46 248.64",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "297.375px 245.055px"
    },
    id: "elhc97t9h9p7u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.41 262.31 290.65 262.16 295.32 249.53 296.07 249.68 291.41 262.31",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "293.36px 255.92px"
    },
    id: "ellhfn99nza4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.04 257.66 296.29 257.51 301.94 242.2 302.69 242.35 297.04 257.66",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "299.49px 249.93px"
    },
    id: "elscmgwp05k77",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.06 263.04 294.3 262.89 295.9 258.54 296.66 258.69 295.06 263.04",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "295.48px 260.79px"
    },
    id: "elezr80umuf07",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.94 249.58 303.18 249.43 305.58 242.93 306.34 243.08 303.94 249.58",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "304.76px 246.255px"
    },
    id: "eles0808avq65",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.7 263.76 297.95 263.61 302.8 250.46 303.56 250.61 298.7 263.76",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "300.755px 257.11px"
    },
    id: "elkwniw5cvz1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.21 262.15 302.45 262 309.23 243.65 309.99 243.81 303.21 262.15",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "306.22px 252.9px"
    },
    id: "elpxevng3rj5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.35 264.49 301.59 264.34 302.07 263.04 302.83 263.19 302.35 264.49",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "302.21px 263.765px"
    },
    id: "elk8u5afo4d1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.18 248.46 311.43 248.31 312.88 244.38 313.63 244.53 312.18 248.46",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "312.53px 246.42px"
    },
    id: "elu44i2m85kd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306 265.22 305.24 265.06 311.04 249.34 311.8 249.5 306 265.22",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "308.52px 257.28px"
    },
    id: "el8ij9jt7wqdu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.16,235.16a44.28,44.28,0,0,1,6.56,1.31,43,43,0,0,1-6.56-1.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "290.44px 235.815px"
    },
    id: "eld9rkwls9hj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9,235.87a42.67,42.67,0,0,1,6.55,1.31,44.41,44.41,0,0,1-6.55-1.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "290.175px 236.525px"
    },
    id: "eldsyk7ywezmu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.85 235.83 284.79 235.62 285.17 234.6 286.23 234.81 285.85 235.83",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "285.51px 235.215px"
    },
    id: "eli10htuah3ep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.1,237.34a43,43,0,0,1,6.56,1.31,43,43,0,0,1-6.56-1.31Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "301.38px 237.995px"
    },
    id: "el7p4g8uc3vdv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.84,238.05a43.88,43.88,0,0,1,6.55,1.3,44.39,44.39,0,0,1-6.55-1.3Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "301.115px 238.7px"
    },
    id: "el0dveth02dcbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.79 238.01 295.73 237.8 296.11 236.78 297.17 236.99 296.79 238.01",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "296.45px 237.395px"
    },
    id: "elyg7vtb1wsrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.67,280.33c2-4.31,8.92-21.27,9.31-28.45s-1.75-34.57-9-38.69c-9.17-5.18-11.15,16.1-11.16,25.44s-8.35,19.25-8.35,19.25l13.38,11.83Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "332.747px 246.359px"
    },
    id: "elg1aureqvtt5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,224a90.57,90.57,0,0,1-.14,9.32,59,59,0,0,1-.62,8.82,26.22,26.22,0,0,1-3.29,8c-.73,1.23-1.52,2.41-2.36,3.57s-1.95,2.46-2.83,3.74c-.09.13-.32,0-.23-.14a64.91,64.91,0,0,0,4.07-7.52,35.76,35.76,0,0,0,2.83-8.37c1.16-5.76,1.06-11.72,2.17-17.49C327.62,223.7,328,223.77,328,224Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.285px 240.646px"
    },
    id: "elzh4carwx81c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,242.13c-.1-6.54-1.81-33.71,9.92-29.69,6.54,3.8,8.32,18,9.08,25-1.26-6.54-3.52-20.72-9.49-24.18-10.11-3.29-8.9,22.88-9.51,28.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.639px 227.083px"
    },
    id: "eldtht6ptp1bn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.74,282l58,47.82s-30.87,47.15-51.8,60.46c-9.88,6.27-29.92,6.3-36.6,3.8-6.24-2.32-41.26-37.26-67.46-100.16C133.57,245,166,257,178.15,269.67c13.1,13.65,47.66,48.66,49.56,48.09S251.74,282,251.74,282Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "228.544px 327.047px"
    },
    id: "el2kujffk8377",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2,299.28c8.75,6.82,17.28,13.9,25.76,21,4.16,3.49,20.14,18,24.75,22.09.18.17-.25.64-.45.49-4.53-3.49-21.43-17.71-25.53-21.27-8.35-7.26-16.65-14.57-24.73-22.13C243.86,299.36,244.05,299.16,244.2,299.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "269.352px 321.066px"
    },
    id: "elxm8mrkyhynb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg60g98fy86t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252,393c-10.47,3.49-25.11,3.15-30.62,1.08-6.24-2.33-41.26-37.27-67.47-100.15-11.16-26.79-6.45-35.3,2.1-35.4C168.36,275.69,219.73,347.48,252,393Z",
    style: {
      opacity: 0.1,
      transformOrigin: "199.678px 327.082px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.8,452.72H60.59c7.5-36.29,40.18-167,66.83-186.33,16.39-11.9,38-3.65,41.72,1.43C184.25,288.68,209.41,419.34,213.8,452.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "137.195px 356.497px"
    },
    id: "ellu67diwcbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66,271.69c0-.07-.12-.05-.12,0,.75,6.38,2,21.19-9.66,21-4.69-.07-9.07-2.32-12.74-4.57a59.84,59.84,0,0,1-10.24-8,82.46,82.46,0,0,1-9.67-10.51c-.12-.16-.4,0-.28.19,2.93,3.74,5.41,7.66,8.77,11.14a51.8,51.8,0,0,0,11.06,8.9c3.92,2.3,8.57,4.53,13.53,4.39a9.51,9.51,0,0,0,9.25-6.71C173.15,282.48,172.8,276.7,171.66,271.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.778px 281.89px"
    },
    id: "elkv4puixlimn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.31,261.29s10.16,54.22,12.08,74.35-4.19,117.08-4.19,117.08H58s24.9-119.22,49.33-165.4C121,261.55,132.31,261.29,132.31,261.29Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "101.382px 357.005px"
    },
    id: "eltgf62rrqcch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,265s16.41,61.33,17.49,67.85,6.53,120.4,6.53,120.4l26.85-.19S190,281.4,167.35,265Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "192.785px 359.125px"
    },
    id: "elusq0163oxxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.6,283.22C72,329.8,33.35,423,45.26,439.09c13.28,18,61.4-47.3,60.71-50.61-.52-2.51,11.89-57.55,21.54-97.68S115.15,271.7,106.6,283.22Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "86.4831px 354.776px"
    },
    id: "el611nhk0u5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.36,388.49c.93-5.83,18.13-78.53,22.75-101.41s-3.45-28.61-22.61-5.56S48.61,378,42.61,415c-5.79,35.58,11.76,33.11,32.71,14.13C92.47,413.56,106.36,388.49,106.36,388.49Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "85.9363px 354.79px"
    },
    id: "ell8sp07nmkdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.36,388.49q7.47-42.33,19-83.8-7.45,42.32-19,83.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.86px 346.59px"
    },
    id: "el8vaj0rbk9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.29,308.82a17.71,17.71,0,0,1-4.18,10.35c1.18-3.51,2.68-6.95,4.18-10.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "124.2px 313.995px"
    },
    id: "elrw4k1obrkj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.26,439.09c10.91,11.72,36,10.71,99.35,14.12,8.77.47,28.74-60.52,19.4-61.5-11.76-1.24-57.67-3.5-61-3.25C74.47,390.64,37.86,431.15,45.26,439.09Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "105.367px 420.827px"
    },
    id: "elueiiibcn2w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.93,393.89s23.32-7.53,36.8-7.7c18.05-.22,33.72,7,40.1,10.45,13.33,7.16,40.6,33.69,34.33,42.88-5.67,8.31-32.18-20.21-32.18-20.21s31.83,24.62,23.15,33.38-37.56-26.1-37.56-26.1,32.13,26,21.76,33.65c-7.84,5.75-35.79-24.35-35.79-24.35S231,458.46,223.2,464.72c-8.63,6.93-36.16-19.24-36.16-19.24-22.53,12.59-38.41,9.36-49.43,5.73C134.94,450.33,152.93,393.89,152.93,393.89Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "201.211px 426.037px"
    },
    id: "elsf6ulbkm2qi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.52,410.09c3.84,2.76,7.75,5.52,11.34,8.61s7.06,6.31,10.34,9.72c8.05,8.36,11.78,14.85,11.51,14.48-6.49-8.9-19.15-20.16-22.74-23.25s-7-6.34-10.57-9.43C221.31,410.14,221.43,410,221.52,410.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.046px 426.488px"
    },
    id: "elcxtl5zc1f94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.13,422.83c4.75,3.73,9.61,7.26,14.2,11.21s8.56,8,12.85,12.28c.33.32,0,.39-.3.08-4.45-4.06-8.88-7.46-13.38-11.46s-8.84-8.18-13.47-12C210,422.88,210.06,422.77,210.13,422.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.67px 434.706px"
    },
    id: "el3xpq24i0dzy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.39,432c7.56,5.33,14.12,12.05,20.4,18.8.32.33-.06.38-.4.06-6.66-6.38-11.85-11.43-20.19-18.6C198.07,432.16,198.23,431.9,198.39,432Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.532px 441.526px"
    },
    id: "elf75zucrf6sr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.73,389.86l-45.56,67.77s-56.4-4.85-66.42-17.73c-6.6-8.48,29.28-51.63,60.94-51.64Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "100.344px 422.945px"
    },
    id: "elzvwyxqccxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,403.26c4.49-4.34,17.4-14.78,35.7-15.06.16,0,.2.26,0,.28-13.61,1.52-30.91,11.18-35.59,15C70.05,403.56,69.91,403.37,70,403.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "87.903px 395.85px"
    },
    id: "elsw6njhnfr59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,449.64c4.61-7.72,9.63-15.19,14.67-22.64s10.07-14.93,15.3-22.26c3-4.14,5.88-8.3,9-12.34.08-.11.28,0,.21.12-4.6,7.71-9.6,15.21-14.58,22.68s-10.07,14.93-15.21,22.33c-2.9,4.17-5.89,8.3-9,12.34C95.22,450.07,94.84,449.86,95,449.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.578px 421.153px"
    },
    id: "elc1sccz3kq8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.72,389.07a77.67,77.67,0,0,0-10.45-.88c-3.5-.16-7-.26-10.5-.33-7-.13-21.71-1.21-34.29.59-.14,0,.67.6.81.57,5.94-1.17,50.06,1.33,53.62,1.09a5,5,0,0,0-.28.77c0,.18.16.38.33.23.4-.36.66-.77,1-1.16A.51.51,0,0,0,156.72,389.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "129.297px 389.292px"
    },
    id: "elmm25s0vi2nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,448c5.58,1.16,13.4,3.43,19,4.89A52.43,52.43,0,0,1,59,448Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.5px 450.445px"
    },
    id: "eltte5u320xh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.79,287.41c-8.3,1-24.1-10.4-28.58-22.6-.31-.84,2.1-8.81,4.57-18.64,1.47-6,3-12.65,3.9-18.84.19-1.27,37.44,15.26,37.44,15.26s-5.77,12.42-7.32,23.23a14.22,14.22,0,0,0-.12,2.58c0,.12,0,.26,0,.43C170.74,273.77,169.67,286.32,160.79,287.41Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "155.151px 257.366px"
    },
    id: "el2j337zg0oj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.69,268.4c0,.12,0,.28,0,.43a27.1,27.1,0,0,1-4-.39c-22.79-3.94-24.53-33.46-24.61-40.89,6.76,2,36.07,15,36.07,15s-5.77,12.43-7.33,23.24A15,15,0,0,0,170.69,268.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.115px 248.19px"
    },
    id: "elvctogeqrah8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.7,178c-5.85,13.34-3.24,54.17,5.55,64.23,12.74,14.6,35.95,18.58,48.94,2.73,12.6-15.37,8.26-68.52-1.77-77.91C178.63,153.24,149.34,158.32,140.7,178Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "170.254px 207.202px"
    },
    id: "elnj84p1iil3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,208.46c0-.1-.21.14-.2.26.18,2.75-.07,5.93-2.53,6.93-.08,0-.06.17,0,.15C176.94,215.27,177.24,211,176.62,208.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "175.361px 212.119px"
    },
    id: "ellh7al65hc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.06,205.68c-4.44-.18-4.47,8.71-.36,8.88S177.78,205.83,174.06,205.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "173.745px 210.12px"
    },
    id: "el9k4cphws5rt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.57,209c0-.11.21.13.21.24-.1,2.75.25,5.93,2.74,6.85.08,0,.07.17,0,.15C192.46,215.78,192,211.57,192.57,209Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "193.968px 212.607px"
    },
    id: "ellzp2wft7xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,206.11c4.43-.32,4.75,8.57.64,8.86S191.32,206.37,195,206.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "195.461px 210.539px"
    },
    id: "elmbaefvrimmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.57,201.59A32.68,32.68,0,0,0,174,200.4c1.31-.48,2.41-.72,3.28-1.9a1.89,1.89,0,0,0-.29-2.28c-1.33-1.18-3.09-1-4.7-.5a6.82,6.82,0,0,0-4,2.95A2,2,0,0,0,170.57,201.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.78px 198.5px"
    },
    id: "elm0zsnz9zmgk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,201.64a32.11,32.11,0,0,1-3.53-.93c-1.36-.37-2.47-.53-3.43-1.63a1.89,1.89,0,0,1,.12-2.3c1.24-1.28,3-1.24,4.65-.86a6.87,6.87,0,0,1,4.17,2.64A2,2,0,0,1,198.5,201.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.01px 198.676px"
    },
    id: "elov32b71xqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,234c.66.65,1.32,1.54,2.32,1.62a7.12,7.12,0,0,0,3-.68c.09,0,.18.06.12.14a3.72,3.72,0,0,1-3.5,1.49,3,3,0,0,1-2.16-2.45C173.67,234,173.88,233.93,174,234Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "176.604px 235.288px"
    },
    id: "elzfjage82dzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,225.79a9.42,9.42,0,0,0,6.25,4.2,11.86,11.86,0,0,0,3.37.16,2.76,2.76,0,0,0,.65-.07,4.6,4.6,0,0,0,.6-.09.69.69,0,0,0,.56-.61v0a2.66,2.66,0,0,0,0-.28v-.27c.06-2.12-.13-5.34-.13-5.34.77.39,4.72,2.18,4.66,1.07-.51-9.18-1.08-19.38-3.53-28.41a.25.25,0,0,0-.5.07c.14,8.84,1.84,17.6,2.12,26.47a16.85,16.85,0,0,0-4.42-1.36c-.3.09.48,6.23.38,7.18a.35.35,0,0,1,0,.1c-3.57.45-6.25-.64-9.7-3.05C177,225.38,176.74,225.57,176.9,225.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.856px 213.069px"
    },
    id: "elhtm1i633thm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.28,229.07a11.15,11.15,0,0,1-4.47,3.44,5,5,0,0,1-3.05.18c-2.2-.59-2.24-2.61-1.83-4.33a12,12,0,0,1,1-2.64A14.42,14.42,0,0,0,185.28,229.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.504px 229.284px"
    },
    id: "eldik674wmh5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.81,232.51a5,5,0,0,1-3.05.18c-2.2-.59-2.24-2.61-1.83-4.33C178.29,228.61,180.61,230.22,180.81,232.51Z",
    style: {
      fill: "rgb(255, 155, 188)",
      transformOrigin: "178.269px 230.604px"
    },
    id: "eltqd7qvsih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.8,182.45C200.6,179,199,178.3,199,178.3s0-4.05-3.62-9.24c-3.82-5.43-8-6.14-8-6.14S183.92,159,176,157.51c-1.82-.34-7.33-.43-9,.26-2,.79-4-.25-6.09-.29a13.57,13.57,0,0,0-5.54,1.07,14.66,14.66,0,0,0-4.06,2.53,22.9,22.9,0,0,0-2,2.08,6.47,6.47,0,0,1-3.51,2.05,11.66,11.66,0,0,0-7.17,6.34,14.94,14.94,0,0,0-1.38,6c-.1,2.59-2.81,3.8-3.83,6a9.73,9.73,0,0,0,1.82,10.6c-3.38,2.42-4.64,7.83-2.83,12.1,1.4,3.3,4.33,4.77,7.29,5.58a8.07,8.07,0,0,0,1.67.27c6.06,1,12-5.66,9.85-12.86v-.06a16.47,16.47,0,0,0,8.31-5.9c2.3-3,3.05-7,3.08-11,7.61,4.8,18.16.07,19.51-9.7,2.17,2.38,8.39,6.4,11.26,5.5,1.24,8.78,7,12,8.52,12C202.1,190.14,203.16,186.39,201.8,182.45Zm-54.37,27.1c1.76-1.83,3.09-4.42,3.72-9.91A9.82,9.82,0,0,1,147.43,209.55Zm24-26.78a15.16,15.16,0,0,0,9.93-9.88C180,178.87,176.12,182,171.46,182.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.033px 184.726px"
    },
    id: "elcki9tqjwe4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,221.18a11.13,11.13,0,1,1,12.37-12.47h0A11.13,11.13,0,0,1,173,221.18Zm2.51-20.61a9.19,9.19,0,0,0-2.4,0,9.63,9.63,0,1,0,2.4,0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "174.331px 210.13px"
    },
    id: "eluwvbz7p0k3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,221.16c-4.23-.52-7.53-5.31-7.51-11.12a13.31,13.31,0,0,1,2.38-7.77,6.94,6.94,0,0,1,11.87,0,13.23,13.23,0,0,1,2.31,7.79c0,6.13-3.76,11.11-8.32,11.09C199,221.2,198.74,221.18,198.5,221.16Zm1.38-20.69a5.44,5.44,0,0,0-.57,0,5.93,5.93,0,0,0-4.74,2.71,11.8,11.8,0,0,0-2.09,6.9c0,5.31,3,9.65,6.75,9.66s6.81-4.29,6.84-9.6a11.79,11.79,0,0,0-2-6.92A6.13,6.13,0,0,0,199.88,200.47Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "199.271px 210.054px"
    },
    id: "el1ho25kqrbrl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,210l-1-1.14c1.7-1.41,5.61-3.3,8.31-.38l-1.09,1C188.81,206.87,185.12,209.87,185,210Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "188.155px 208.472px"
    },
    id: "elz16lqly4ku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.38,212.65l-1.31-.69c.32-.61,3.23-6,6.55-6.54,3.11-.48,23,1.47,23.89,1.55l-.15,1.48c-5.71-.56-21.1-1.94-23.5-1.56C138.66,207.23,136.16,211.17,135.38,212.65Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "149.29px 208.997px"
    },
    id: "elc84nvnbpgv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.93,212.24s-7.8-13.84-14-11.18-1.21,22.09,5.44,25.33a7.05,7.05,0,0,0,9.77-2.85Z",
    style: {
      fill: "rgb(173, 99, 89)",
      transformOrigin: "139.122px 214.026px"
    },
    id: "elbug4y4yp0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.51,206.6a.1.1,0,0,0-.06.18c4.65,2.43,6.76,7.16,8.09,12-1.26-1.93-3.13-3.11-5.69-1.63-.14.08,0,.29.1.27a4.36,4.36,0,0,1,4.61,2,20.68,20.68,0,0,1,1.9,4.07c.18.45,1,.3.87-.22l0-.11C145,217,141.07,207.86,134.51,206.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.407px 215.178px"
    },
    id: "el4r22o0lw94g",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppDataAnimate);
export default __webpack_public_path__ + "static/media/app-data-animate.5ce52161edf01cd0630c35792142349e.svg";
export { ForwardRef as ReactComponent };